import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Modal } from "../Modal";
import MarkdownTextArea from "../MarkdownTextArea";
import Button from "../Button";

import {
    ISeedCategory,
    ISeedProductClone,
    ISeedIcon,
    ISeedProduct,
} from "../../infrastructure/interfaces";
import { cloneSeedProduct } from "../../actions/actions";

interface ISeedFormState {
    bulletPointMarkdown: string;
    formValid: boolean;
}

//from redux store
interface StateProps {
    seedCategoryList: ISeedCategory[];
    seedIconList: ISeedIcon[];
}
const mapStateToProps = (state: any): StateProps => {
    return {
        seedCategoryList: state.seedCategoryList,
        seedIconList: state.seedIconList,
    };
};

//from redux store
interface DispatchProps {
    cloneSeedProduct(seed: ISeedProductClone): void;
}

const mapDispatchToProps = (dispatch: any): DispatchProps => {
    return {
        cloneSeedProduct: (seed: ISeedProductClone) => {
            dispatch(cloneSeedProduct(seed));
        },
    };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type ISeedFormProps = PropsFromRedux & {
    seed: ISeedProduct;
    onClose: () => void;
    show: boolean;
};

class SeedForm extends React.Component<ISeedFormProps, ISeedFormState> {
    constructor(props: ISeedFormProps) {
        super(props);
        this.state = {
            bulletPointMarkdown: this.props.seed.bulletPointMarkdown,
            formValid: true,
        }
        this.cloneSeedProduct = this.cloneSeedProduct.bind(this);
    }

    componentDidUpdate(_: ISeedFormProps, prevState: ISeedFormState) {
        // Compare previous state and current state to determine if validity check
        // need to be performed
        const validatableFieldsChanged = this.checkValidatableFieldsForChange(
            prevState,
            this.state
        );

        if (validatableFieldsChanged) {
            const formValid = this.isFormValid();
            this.setState({ formValid });
        }
    }

    isFormValid(): boolean {
        return (this.state.bulletPointMarkdown.length <= 550);
    }

    checkValidatableFieldsForChange(
        prevState: ISeedFormState,
        curState: ISeedFormState
    ): boolean {
        const {
            bulletPointMarkdown: prevBulletPointMarkdown,
        } = prevState;
        const {
            bulletPointMarkdown: curBulletPointMarkdown,
        } = curState;

        return (prevBulletPointMarkdown !== curBulletPointMarkdown)
    }


    cloneSeedProduct() {

        const clonedSeedSubmit = {
            bulletPointMarkdown: this.state.bulletPointMarkdown,
            seedToCloneId: this.props.seed.id
        }
        this.props.cloneSeedProduct(clonedSeedSubmit);
        this.props.onClose();
    }

    handleSeedBulletPointMarkdownChange(bulletPointMarkdown: string) {
        this.setState({ bulletPointMarkdown });
    }

    renderForm() {
        return (
            <div className="productInfoContainer">
                <div className="productInfoInputContainer">
                    <label>Bullet Points (max of 550 characters)</label>
                    <MarkdownTextArea
                        textValue={this.state.bulletPointMarkdown}
                        onChange={(text) =>
                            this.handleSeedBulletPointMarkdownChange(text)
                        }
                    />
                </div>
            </div>
        );
    }

    render() {
        return (
            <Modal show={this.props.show} onClose={this.props.onClose}>
                <Modal.Header>
                    <Modal.Title>
                        <h2>{this.props.seed.name}</h2>
                    </Modal.Title>
                    <Button
                        bsClass="close"
                        onClick={this.props.onClose}
                    ></Button>
                </Modal.Header>
                <Modal.Body>{this.renderForm()}</Modal.Body>

                <Modal.Footer>
                    <Button
                        bsClass="cancel"
                        onClick={() => this.props.onClose()}
                    >
                        Cancel
                    </Button>
                    <Button
                        bsClass="primary"
                        onClick={this.cloneSeedProduct}
                        disabled={!this.state.formValid}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
export default connector(SeedForm);



// WEBPACK FOOTER //
// ./src/components/Products/SeedCloneForm.tsx